import {ColumnTypeMapping, ColumnCodeMapping, ColumnZoomTypeMapping} from '../consts/columnTypes';
import {getDateFormat} from '../../../Localization/date';
import {hiddenFieldTypes} from '../../../constants/FieldConsts';

import {ColumnType as ColumnTypeValues} from 'priority-web-sdk/enums';
import {ColumnType, ColumnZoomType, ColumnCode} from 'priority-web-sdk';

export interface InputJson {
    attachment: string;
    boolean: string;
    cover: string;
    decimal: string;
    defaultvalue: string;
    field: string;
    full: string;
    hasdefault: string;
    hasexplorer: string;
    hasolap: string;
    hasprefield: string;
    height: string;
    instantmessaging: string;
    isstatus: string;
    mandatory: string;
    multienv: string;
    readonly: string;
    relcol?: string;
    searchall: string;
    table: string;
    title: string;
    type: string; // ASCII
    userwidth: string;
    width: string;
    zoom: string;
    zoomcolumn: string;
    zoomfname: string;
    zoomname: string;
}

export interface Column {
    field: string;
    /** Indicates whether files can be attached in this field. 0 or 1. */
    attachment: boolean;
    /** Field’s code (database type) */
    code: ColumnCode;
    /** Indicates whether the field is boolean 0 or 1 */
    boolean: boolean;
    /** For decimal fields, the decimal precision. */
    decimal: number;
    /** In date fields, the field’s format, e.g. ‘DD/MM/YY’. */
    format: string;
    /** Indicates whether the field is mandatory. 0 or 1. */
    mandatory: boolean;
    /** Maximum number of characters in the field. Used for text and number fields. */
    maxLength: number;
    /** Indicates whether the field is read-only. 0 or 1. */
    readonly: boolean;
    /** Field’s title that should be displayed to the user. */
    title: string;
    /** Field’s type, one of ColumnType enum */
    type: ColumnType;
    /** Field status, one of hiddenFieldTypes enum */
    hidden: hiddenFieldTypes;
    /** Fields zoom type. Used for indicating if and what type of "zoom" can be made into the field. One of ColumnZoomType enum. */
    zoom: ColumnZoomType;
    name: string;
    isSearchAll: boolean;
    isStatus: boolean;
    zoomFname: string;
    relColName: string;
}

function columnType(type, isBoolean: string) {
    if (isBoolean === '1') {
        return ColumnTypeValues.Bool;
    }
    return ColumnTypeMapping[String.fromCharCode(type)];
}

function columnZoomType(zoom) {
    return ColumnZoomTypeMapping[Number(zoom)];
}

function columnCode(type) {
    return ColumnCodeMapping[String.fromCharCode(type)];
}

export function serialize(column: InputJson, designedColumn): Column {
    const {
        field,
        decimal,
        attachment,
        boolean,
        mandatory,
        width,
        readonly,
        title,
        zoom,
        type,
        zoomname,
        searchall,
        isstatus,
        zoomfname,
        relcol
    } = column;
    const undefinedNamePlaceholder = 'XXX_XXX';
    const format = getDateFormat(columnType(type, boolean), columnCode(type));
    return {
        field,
        title: designedColumn ? designedColumn.title : title,
        hidden: designedColumn ? designedColumn.hidden : hiddenFieldTypes.SHOWN,
        format,
        decimal: Number(decimal),
        attachment: attachment === '1',
        mandatory: mandatory === '1',
        maxLength: Number(width),
        readonly: readonly === '1',
        type: columnType(type, boolean),
        code: columnCode(type),
        zoom: columnZoomType(zoom),
        name: zoomname,
        boolean: boolean === '1',
        isSearchAll: searchall === '1',
        isStatus: isstatus === '1',
        zoomFname: zoomfname !== undefinedNamePlaceholder ? zoomfname : null,
        relColName: relcol !== undefinedNamePlaceholder ? relcol : null
    };
}
